const Section = ({ title, children }) => (
  <section className="mt-6">
    <h2 className="font-display text-xl font-bold text-slate-900">{title}</h2>
    <div className="mt-2 space-y-2 text-lg text-slate-700">{children}</div>
  </section>
);

const Page = ({ title, children, testId }) => (
  <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6" data-testid={testId}>
    <h1 className="font-display text-3xl font-extrabold text-slate-900 sm:text-4xl">{title}</h1>
    {children}
  </div>
);

export function Terms() {
  return (
    <Page title="Termos de uso" testId="terms-page">
      <Section title="1. O que é o Prestadores Online">
        <p>Somos uma plataforma que aproxima clientes e prestadores de serviço em Goiânia e região. Não somos empregadores dos prestadores e não executamos os serviços.</p>
      </Section>
      <Section title="2. Conta">
        <p>Cada pessoa tem uma única conta, que serve para pedir serviços e, se quiser, para trabalhar como prestador. Você é responsável pelos dados informados.</p>
      </Section>
      <Section title="3. Prestadores">
        <p>Todo prestador passa por análise antes de aparecer. Podemos reprovar ou bloquear cadastros com informações falsas ou mau comportamento.</p>
        <p>Cada prestador tem 5 pedidos aceitos grátis. Depois disso, é preciso assinar o plano Pro para continuar recebendo pedidos.</p>
      </Section>
      <Section title="4. Orçamento e pagamento do serviço">
        <p>Valor, data e forma de pagamento do serviço são combinados diretamente entre cliente e prestador pelo WhatsApp.</p>
      </Section>
      <Section title="5. Avaliações">
        <p>Depois do serviço concluído, o cliente pode avaliar o prestador com nota e comentário. Avaliações ofensivas podem ser removidas.</p>
      </Section>
    </Page>
  );
}

export function Privacy() {
  return (
    <Page title="Política de privacidade" testId="privacy-page">
      <p className="mt-3 text-lg text-slate-700">Seguimos a Lei Geral de Proteção de Dados (LGPD). Coletamos só o necessário para o serviço funcionar.</p>
      <Section title="Localização">
        <p>A localização do seu celular só é usada, com sua permissão, para achar prestadores próximos. Ela não é compartilhada com ninguém.</p>
        <p>Do prestador guardamos apenas o bairro e a cidade (localização aproximada). Nunca mostramos o ponto exato.</p>
      </Section>
      <Section title="Dados que guardamos">
        <p>Nome, e-mail, WhatsApp, pedidos, fotos enviadas e avaliações.</p>
      </Section>
      <Section title="Quem vê seu WhatsApp">
        <p>O WhatsApp do cliente só aparece para o prestador que aceitou o pedido. O WhatsApp do prestador só aparece para o cliente depois do aceite.</p>
      </Section>
      <Section title="Avisos">
        <p>Enviamos notificações, e-mails e mensagens de WhatsApp apenas sobre seus pedidos.</p>
      </Section>
      <Section title="Seus direitos">
        <p>Você pode pedir a correção ou exclusão dos seus dados a qualquer momento falando com o administrador.</p>
      </Section>
    </Page>
  );
}
